import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/UploadBoxerImages";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/upload-boxer/")({
  head: () => routeHead("/admin/upload-boxer/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
